exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sidebar-dark .nav-sidebar>.nav-item-submenu>.nav-group-sub[data-v-1febfb58]{background-color:hsla(0,0%,100%,.5)}.sidebar-expand-lg.sidebar-main-resized:not(.sidebar-main-unfold) .nav-sidebar .nav-item-header[data-v-1febfb58],.sidebar-expand-lg.sidebar-main-resized:not(.sidebar-main-unfold) .nav-sidebar .nav-link[data-v-1febfb58],.sidebar-expand-lg.sidebar-main-resized:not(.sidebar-main-unfold) .sidebar-main-header[data-v-1febfb58]{padding-left:6px;padding-right:0;-ms-flex-pack:center;justify-content:center}.nav-sidebar .nav-item[data-v-1febfb58]:not(.nav-item-header):last-child{padding-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1febfb58","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/navigation/menu-item.vue
// module id = 1832
// module chunks = 0